import { cn } from "@/lib/utils";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        "aero:bg-accent aero:animate-pulse aero:!rounded-md",
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
